var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMessageSms = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 250 250"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#34C759",
  d: "M194.94 0H55.06C24.65 0 0 24.651 0 55.06v139.88C0 225.349 24.651 250 55.06 250h139.88c30.409 0 55.06-24.651 55.06-55.06V55.06C250 24.65 225.349 0 194.94 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M125 43.277c-24.336 0-47.675 8.053-64.884 22.386C42.908 79.997 33.24 99.437 33.24 119.707c.022 13.185 4.14 26.141 11.95 37.608 7.812 11.468 19.052 21.058 32.628 27.837-3.616 8.096-9.039 15.687-16.045 22.459 13.586-2.385 26.34-7.395 37.268-14.64A109 109 0 0 0 125 196.137c24.336 0 47.676-8.053 64.884-22.386 17.208-14.334 26.876-33.774 26.876-54.044s-9.668-39.71-26.876-54.044S149.336 43.278 125 43.277"
})));
export default SvgMessageSms;